// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { SESSION_SET_SESSION } from './constants';

export function setSession(data) {
  return {
    type: SESSION_SET_SESSION,
    data: {
      id: data.id,
      name: data.name,
      role: data.role,
    },
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SESSION_SET_SESSION:
      return {
        ...state,
        authenticated: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/session/redux/setSession.js